import {CreateObject} from "../class/createObject";
import _ from 'underscore'

export class Code {
    constructor(scene, group) {
        this.scene = scene;
        this.groupCode = group;
        this.dbCode = scene.dbCode = {
            timeToNew: null,
            items: []
        };
        this.scene.physics.add.collider(this.groupCode, this.groupCode)
        this.object = new CreateObject(this.dbCode, scene, group, 'code')
    }

    generateCode() {
        this.object.generate();
    }

    pickUp(id, value) {
       let index = _.findIndex(this.dbCode.items, (element, index) => {
            return element.id === id;
        });
        if (index >= 0) {
            let coin = + this.scene.character.positiveEffects.coin.value;
            let manager = this.scene.character.negativeEffects.manager.value;
            this.scene.projectLine += value + coin - manager;
            this.scene.modelBar.updateProgress(this.scene.projectLine);
            this.dbCode.items.splice(index, 1)
        }
    }
}
